import './App.css';
import MainSection from './components/mainSection'

function App() {
  return (
    <div className="App">
      <MainSection></MainSection>
    </div>
  );
}

export default App;
